exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".text-center[data-v-f525e792]{text-align:center}", "", {"version":3,"sources":["/workspace/src/views/invoice-apply/components/ticket-split/InvoiceTicketSplitDetail.vue"],"names":[],"mappings":"AACA,8BAA8B,iBAAiB,CAC9C","file":"InvoiceTicketSplitDetail.vue","sourcesContent":["\n.text-center[data-v-f525e792]{text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f525e792","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/invoice-apply/components/ticket-split/InvoiceTicketSplitDetail.vue
// module id = 4297
// module chunks = 35